export default __webpack_public_path__ + "static/media/sooz.f9b53acd.jpg";